import Link from "next/link";
import { useRouter } from "next/router";
import { IOfferModeWithFSecure } from "@nju/data-access-portal-offers";
import { Icon } from "@nju/icons";
import { portalRoutes } from "@nju/routes";
import { A, Button, Panel, Separator, Text } from "@nju/ui";

interface ICancelOrderErrorProps {
  mode: IOfferModeWithFSecure;
}

export function CancelOrderError({ mode }: ICancelOrderErrorProps) {
  const router = useRouter();

  return (
    <Panel>
      <div className="flex items-center flex-col">
        <Text
          size={{
            "@onlyMobile": "m",
            "@fromTablet": "keyS",
          }}
          weight="bold"
        >
          coś poszło nie tak
        </Text>
        <Separator size="s" tone="invisible" />
        <Icon
          className="w-12 h-12 from-tablet:w-[90px] from-tablet:h-[90px]"
          name="exclamation-circle-incircle"
        />
        <Separator size="xs" tone="invisible" />
        <Text
          align="center"
          size={{
            "@onlyMobile": "s",
            "@fromTablet": "m",
          }}
        >
          Wystąpił niespodziewany błąd techniczny, spróbuj jeszcze raz.
        </Text>
      </div>
      <Separator size="xs" tone="invisible" />
      <div className="flex justify-center only-mobile:flex-col-reverse">
        <Link href={portalRoutes.mojeKonto.index.get({ mode })} passHref={true}>
          <A
            className="mt-3 from-tablet:mt-0 from-tablet:mr-4"
            size={{
              "@onlyMobile": "s",
              "@fromTablet": "m",
            }}
            variant="secondary"
          >
            anuluj
          </A>
        </Link>
        <Button
          onPress={router.reload}
          size={{
            "@onlyMobile": "s",
            "@fromTablet": "m",
          }}
        >
          spróbuj ponownie
        </Button>
      </div>
    </Panel>
  );
}
